export default __webpack_public_path__ + "static/media/ic-indirect-ownership.fa825320.svg";